import PropTypes from 'prop-types';
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const CouponDeepLinkContext = createContext({ isCouponsCodesVisible: false });

const CouponDeepLinkProvider = ({ children }) => {
  const [isCouponsCodesVisible, setCouponsCodesVisible] = useState(false);

  const revealCouponCodes = useCallback(() => {
    setCouponsCodesVisible(true);
  }, []);

  const value = useMemo(
    () => ({ isCouponsCodesVisible, revealCouponCodes }),
    [isCouponsCodesVisible, revealCouponCodes]
  );

  return (
    <CouponDeepLinkContext.Provider value={value}>
      {children}
    </CouponDeepLinkContext.Provider>
  );
};

export const useCouponDeepLink = () => useContext(CouponDeepLinkContext);

CouponDeepLinkProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CouponDeepLinkProvider;
